export function moduloSeguridadNormalize(row) {
  return {
    idModulo: row.idModulo ?? row.IdModulo ?? row['IdModulo'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    rutaBase: row.rutaBase ?? row.RutaBase ?? row['RutaBase'] ?? '',
    icono: row.icono ?? row.Icono ?? row['Icono'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
    orden: row.orden ?? row.Orden ?? row['Orden'] ?? 0,
  };
}
